import { Data as Data$1 } from './contract/contract-surety-bond-form.types.mjs';
import * as contractSuretyBondForm_types from './contract/contract-surety-bond-form.types.mjs';
export { contractSuretyBondForm_types as Contract };

var Data;
(function (Data) {
    Data.schema = Data$1.schema;
})(Data || (Data = {}));

export { Data };
